import { ADJUST_TEXT_SIZE, CHANGE_LANG } from "./actions.types";

export const adjustFontSize = (sizeFactor) => ({
    type: ADJUST_TEXT_SIZE,
    payload: sizeFactor
})

export const changeLang = (langCode) => ({
    type: CHANGE_LANG,
    payload: langCode
})